
import SimpleChat from '../../../videochat/chat/simple-chat/direct-chat'
import PubNub from "pubnub";
import { PubNubProvider } from "pubnub-react";
import React, { useEffect, useState } from 'react'
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

const Messages = (props) => {
  const [headerText, setHeadertext] = useState("")
  const [channel, setChannel] = useState("")

  useEffect(() => {
    console.log(localStorage.getItem("loggedInUser"))
    console.log(props.formValues, "data")
    console.log("dm_" + localStorage.getItem("loginUserId") + '_' + props.formValues.patientdata.patientId, "channelid")
    setChannel("dm_" + localStorage.getItem("loginUserId") + '_' + props.formValues.patientdata.patientId)
    setHeadertext(`Chat with ${props.formValues.patientdata.firstName}`)
  }, [])
  const pubnub = new PubNub({
    "publishKey": process.env.REACT_APP_PUBNUB_PUBLISHKEY,
    "subscribeKey": process.env.REACT_APP_PUBNUB_SUBSCRIBEKEY,
    userId: localStorage.getItem("loggedInUser"),
  });
  return (
    <div className="card mt2rem">
      <div className="card-body">
        <div className="chat-container col-md-7">
           {channel ? 
          <PubNubProvider client={pubnub}>
           <SimpleChat clientId={localStorage.getItem("loginUserId")} channel={{ name: channel, clientname: localStorage.getItem("loggedInUser") }} clientname={localStorage.getItem("loggedInUser")} header={headerText} />
          </PubNubProvider> : "No Data Found"}
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = (state) => {
  return {
    formValues: state.form,
  };
};

export default withRouter(
  connect(mapStateToProps, null)(Messages)
);
